export enum TodayTomorrow {
	Today,
	Tomorrow,
}
